import { Component, ViewEncapsulation, input } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrl: './spinner.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom,
    host: {
        '[class.size-small]': 'size() === "small"',
        '[class.size-tiny]': 'size() === "tiny"'
    }
})
export class SpinnerComponent {
    type = input<'infinitform' | 'simple'>('infinitform');
    size = input<'default' | 'small' | 'tiny'>('default');
}
